import {inject, observer} from 'mobx-react';
import React, {useEffect, useState} from 'react';
import MicrolessonsPreviewStore from '../store/MicrolessoonsPreviewStore';
import {LessonPresentation} from '../../../../data/models/Course/LessonPresentation';
import {useNavigate, useParams} from 'react-router-dom';
import {VideoPlayback} from '../../../VideoPlayback';

interface Props {
  microlessonsPreviewStore?: MicrolessonsPreviewStore;
}

const MicrolessonsPreviewContainer = inject('microlessonsPreviewStore')(
  observer(({microlessonsPreviewStore}: Props) => {
    const [lessonPrevew, setLessonPreview] = useState<LessonPresentation>();

    const navigate = useNavigate();
    const {organizationId, lessonId} = useParams();

    useEffect(() => {
      if (organizationId && lessonId) {
        microlessonsPreviewStore!
          .getMicrolessonsPreview(organizationId, lessonId)
          .then(setLessonPreview);
      }
    }, [lessonId]);

    const onBack = () => {
      navigate(-1);
    };

    const getPassingScore = () => {
      return lessonPrevew?.currentLesson?.passingScore;
    };

    return lessonPrevew ? (
      <VideoPlayback
        presentation={lessonPrevew}
        currentLessonId={lessonId || ''}
        preview={true}
        onBack={onBack}
        onContinue={onBack}
        onCourseHome={onBack}
        finishedLessons={[]}
        onOpenLesson={() => {
          //nothing
        }}
        passingScore={getPassingScore()}
        isLoading={microlessonsPreviewStore?.isLoading}
        onFinishedLesson={onBack}
        navigateToLesson={() => {
          //nothing
        }}
      />
    ) : null;
  }),
);

export default MicrolessonsPreviewContainer;
